module.exports = __webpack_public_path__ + "static/media/loading.7ed413fa.gif";